import { CapacitiesList, CapacitiesRow } from "../../api";
import * as ReduxToolkit from "@reduxjs/toolkit";

export interface State {
    capacities?: CapacitiesRow[];
}

export function initState(): State {
    return {};
}

export const capacitySlice = ReduxToolkit.createSlice({
    name: "capacity",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        clearCapacities: (state) => {
            delete state.capacities;
            return state;
        },
        updateCapacities: (
            state,
            action: ReduxToolkit.PayloadAction<CapacitiesRow[]>
        ) => {
            state.capacities = action.payload;
            return state;
        },
        updateSelectedCapacity: (
            state,
            action: ReduxToolkit.PayloadAction<CapacitiesRow>
        ) => {
            for (const row of state.capacities!) {
                if (row.driverId == action.payload.driverId) {
                    if (action.payload.capTrips == -1) {
                        // 上限なし
                        row.capTrips = undefined;
                    } else {
                        row.capTrips = action.payload.capTrips;
                    }
                    row.capPrice = action.payload.capPrice;
                }
            }
        },
    },
});
